
export default {
  customerDialog: {
    type: 'new', // ie new or edit?
    show: false,
    saving: false,
    showResponse: false,
    responseMessage: null,
    responseType: null,
    submitHandler: null,
    submitLabel: 'Create',
    cancelLabel: 'Cancel',
    isSingleMp: false,
    loadingRequest: false,
    fields: {
      Cust_Region: null,
      Customer_Name: null,
      Customer_Region: null,
      Customer_Alias: null,
      Master_Id: null
    }
  },
  emailAuditList: [],
  emailAuditHeaders: [
    {
      sortable: true,
      text: 'Id',
      value: 'Id'
    },
    {
      sortable: true,
      text: 'Sent Date',
      value: 'Sent_Date'
    },
    {
      sortable: true,
      text: 'Success',
      value: 'Success'
    },
    {
      sortable: true,
      text: 'Module',
      value: 'Module'
    },
    {
      sortable: true,
      text: 'Sender',
      value: 'Sender'
    },
    {
      sortable: true,
      text: 'Recipient',
      value: 'Recipient'
    },
    {
      sortable: true,
      text: 'Cc',
      value: 'Cc'
    },
    {
      sortable: true,
      text: 'Subject',
      value: 'Subject'
    },
    {
      sortable: true,
      text: 'Message Body',
      value: 'Message_Body'
    }
  ],
  customerHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: 'action'
    },
    {
      sortable: true,
      text: 'Customer Name',
      value: 'Customer_Name'
    },
    {
      sortable: true,
      text: 'Customer Region',
      value: 'Customer_Region'
    },
    {
      sortable: true,
      text: 'Customer Alias',
      value: 'Customer_Alias'
    },
    {
      sortable: true,
      text: 'MP ID',
      value: 'Master_Id'
    }
  ],
  customerListLoading: false,
  customers: [],
  accountDialog: {
    type: 'new', // ie new or edit?
    show: false,
    search: null,
    showSelectCustomer: true,
    selectedCustomer: null,
    continueEnabled: true,
    customers: [],
    customerList: [],
    saving: false,
    savingAWSLaunchDate: false,
    savingDateSentToAWS: false,
    saved: false,
    submitHandler: null,
    closeHandler: null,
    submitLabel: 'Submit',
    cancelLabel: 'Cancel',
    alertType: false,
    alertMessage: false,
    step: 0,
    valid: true,
    accountIdExist: false,
    mpIdExist: false,
    accountIdExistError: false,
    accountIdExistErrorMessages: [],
    accountIdExistSuccess: false,
    accountIdExistSuccessMessages: [],
    accountIdExistLoading: false,

    opportunityNumberExistError: false,
    opportunityNumberExistErrorMessages: [],
    opportunityNumberExistSuccess: false,
    opportunityNumberExistSuccessMessages: [],
    opportunityNumberExistLoading: false,

    mpIdExistError: false,
    mpIdExistErrorMessages: [],
    mpIdExistSuccess: false,
    mpIdExistSuccessMessages: [],
    mpIdExistLoading: false,
    validatePrevMpId: false,
    checkingCustomerLoading: false,

    OppRegIdExistError: false,
    OppRegIdExistErrorMessage:[],
    OppRegIdExistSuccess:false,
    OppRegIdExistSuccessMessage:[],
    OppregIdStatus: true,
    OppRegIdExistLoading:false,
    OppregIdValidated: false,
    
    isWorkload: false,
    workloads: [],

    dates: {
      date_onboarded: false,
      last_date_validate: false,
      date_requested_change: false,
      wbs_expiration_date: false,
      iwo_expiration_date: false,
      end_date: false,
      aws_launch_date: false,
      date_sent_to_aws: false,
      date_suspended: false
    },
    fields: {
      Acct_Restricted: null,
      Acct_ID: null,
      Project_Id:null,
      OppReg_Id: null,
      ACE_Opportunity_Number: null,
      Acct_name: null,
      Acct_DL: null,
      Date_onboarded: null,
      Last_Date_Validated: null,
      Date_Suspended: null,
      Date_Requested_change: null,
      Master_Id: null,
      MP_ID: null,
      MP_Name: null,
      DateMarkedAsUnknown: null,
      Previous_MP_ID: null,
      Managed_Svc: 'None',
      FG_Name: null,
      POD_Id: null,
      Acct_status: 'New',
      Acct_Offering_Stat: null,
      Acct_Status: null,
      AWS_Support_Type: null,
      Customer_Type: null,
      Is_MP: null,
      Customer_Id: null,
      Customer_Name: null,
      Customer_Region: null,
      Customer_Alias_Group: null,
      Del_Flag: 0,
      // Ext_Account_Id: null,
      Acct_Description: null,
      // unique agreements
      DXC_discount: null,
      DXC_uplift: null,
      Client_discount: null,
      Client_uplift: null,
      Contract_description: null,
      Account_notes: null,
      // financial
      WBS_code: null,
      WBS_expiration_date: null,
      IWO_Reqd: null,
      IWO_Code: null,
      IWO_expiration_date: null,
      // expiration
      Credit_amount: null,
      Account_expire_on_credits: null,
      End_date: null,
      Account_expire_on_end_date: null,
      R_Code: null,
      // security
      MFA: null,
      Root_Credential_Store: null,
      //contacts
      Notification_List: [],
      IAM_Users: [],
      Financial_Owner:[],
      // comments
      Comments: null,
      Acct_Alias_Group: 'None', 
      Onboard_Date_Lock: null,
      AWS_Usage_Type: null,
      AWS_Government_Customer: null,
      AWS_Advising_Government: null,
      GovCloud_Resource_Account: null
    }
  },
  mpDialog: {
    type: 'new',
    show: false,
    saving: false,
    showResponse: false,
    responseMessage: null,
    responseType: null,
    submitHandler: null,
    submitLabel: 'Create',
    mpIdValidation: {
      isValidated: false,
      isLoading: false,
      error: false,
      errorMessage: '',
      success: false,
      successMessage: ''
    },
    fields: {
      Master_Id: null,
      MP_ID: null,
      Agreement: null,
      AWS_Support_Type: null,
      Type: null,
      MP_discount: null,
      MP_uplift: null,
      MP_Business_Rules: null,
      MP_features: null,
      MP_Type: null,
      Sync_Config: {
        Customer_Id: null,
        Managed_Services: null,
        WBS_code: null,
        IWO_code: null
      },
      Grandfathered: null,
      CT_Log_Usage: null
    }
  },

  financeDialog: {
    type: 'new', // ie new or edit?
    show: false,
    saving: false,
    saved: false,
    showResponse: false,
    responseMessage: null,
    responseType: null,
    submitHandler: null,
    submitLabel: 'Create',
    cancelLabel: 'Cancel',
    sfdcValidation: {
      validating: false,
      validated: false,
      validationMessage: ''
    },
    fields: {
      Id: null,
      // Financial_Period_Id:null,
      PayerAccountId: null,
      LinkedAccountId: null,
      LinkedAccountName: null,
      Service_Period: null,
      Service_Product: null,
      CloudCheckr_Cost: null,
      Additional_Discount: null,
      Uplift: null,
      Credit_Backbill: null,
      Tota_Costs_to_Allocate: null,
      Estimated_Monthly_Revenue: null,
      Estimated_Twelve_Month_Revenue: null,
      Can_Allocate: null,
      WBS: null,
      WBS_End_Date: null,
      IWO_Number: null,
      Originating_Org_WBS: null,
      Cost_Center: null,
      Client_Name: null,
      Horizon_Client_Name: null,
      Revenue_Missing_from_Horizon: null,
      Region: null,
      Account_Type: null,
      Major_Offering_Code: null,
      Major_Offering_Name: null,
      SFDC_Opp_ID: null,
      SFDC_Opp_Status: null,
      AWS_on_Opp: null,
      Financial_System: null,
      CR_Redeemed_from_AWS: null,
      CR_Used: null,
      CR_Remaining: null,
      Exceptions: null,
      AWS_Discount: null,
      DXC_Discount: null,
      Contract: null,
      Notes: null,
      Galaxy_Service_Level: null
    }
  },
  masterPayers: [],
  mPayers: [],
  mPayersDialog: {
    type: 'edit', // ie new or edit?
    show: false,
    saving: false,
    showResponse: false,
    responseMessage: null,
    responseType: null,
    submitHandler: null,
    submitLabel: 'Update',
    cancelLabel: 'Cancel',
    fields: {
      MP_ID: null,
      Agreement: null,
      AWS_Support_Type: null,
      Type: null,
      MP_discount: null,
      MP_uplift: null,
      MP_Business_Rules: null,
      MP_features: null,
      MP_Type: null
    }
  },
  masterPayerHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: 'action'
    },
    {
      sortable: true,
      text: 'MasterPayer ID',
      value: 'MP_ID'
    },
    {
      sortable: true,
      text: 'Agreement',
      value: 'Agreement'
    },
    {
      sortable: true,
      text: 'AWS Support Type',
      value: 'AWS_Support_Type'
    },
    {
      sortable: true,
      text: 'Type',
      value: 'Type'
    },
    {
      sortable: true,
      text: 'MasterPayer Discount',
      value: 'MP_discount'
    },
    {
      sortable: true,
      text: 'MasterPayer Uplift',
      value: 'MP_uplift'
    },
    {
      sortable: true,
      text: 'MasterPayer Business Rules',
      value: 'MP_Business_Rules'
    },
    {
      sortable: true,
      text: 'MasterPayer Features',
      value: 'MP_features'
    },
    {
      sortable: true,
      text: 'MasterPayer Type',
      value: 'MP_Type'
    },
    {
      sortable: false,
      text: 'Grandfathered',
      value: 'Grandfathered'
    },
  ],
  masterPayerListLoading: false,
  linkedAccountsReportGenerated: false,
  linkedAccountForm: {
    id: null,
    mpid: null,
    show: false,
    accountHeaders: [
      {
        sortable: true,
        text: 'ID',
        value: 'Acct_ID',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Account Name',
        value: 'Acct_name',
        align: 'left'
      }
    ],
    accounts: [],
    // pagination: {
    //   descending: true,
    //   page: 1,
    //   rowsPerPage: 10,
    //   totalItems: 0
    // }
  }
}
